// extracted by mini-css-extract-plugin
export var aboutDiv = "index-module--about-div--fd2f6";
export var aboutTextDiv = "index-module--about-text-div--af112";